module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.$route.query.letterDetail !== '1') ? _c('div', {
    staticClass: "mIndex"
  }, [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "email_box"
  }, [_c('div', {
    staticClass: "left_box"
  }, [_c('p', {
    staticClass: "write_title"
  }, [_vm._v("校长信箱")]), _vm._v(" "), _c('div', {
    staticClass: "write_way",
    on: {
      "click": _vm.toWriteEmail
    }
  }, [_vm._v("我要写信")])]), _vm._v(" "), _c('div', {
    staticClass: "right_box"
  }, [_c('p', {
    staticClass: "write_title"
  }, [_vm._v("进度查询")]), _vm._v(" "), _c('div', {
    staticClass: "write_way",
    on: {
      "click": _vm.jdcx
    }
  }, [_vm._v("我的信件")])])]), _vm._v(" "), _c('section', {
    staticClass: "email_show"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "wrapper"
  }, [_vm._l((_vm.dataList), function(item) {
    return _c('div', {
      key: item.WID,
      staticClass: "item",
      on: {
        "click": function($event) {
          return _vm.openDetail(item.WID)
        }
      }
    }, [_c('div', {
      staticClass: "item_title"
    }, [_c('div', {
      staticClass: "dot"
    }, [_vm._v("●")]), _vm._v(" "), _c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.TITLE))])]), _vm._v(" "), _c('div', {
      staticClass: "item_info"
    }, [_c('p', [_vm._v("浏览量：" + _vm._s(item.READNUM))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.CREATE_TIME.substr(0, 10)))])])])
  }), _vm._v(" "), (_vm.dataList && _vm.dataList.length == 0) ? _c('div', {
    staticClass: "empty"
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/assets/empty.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("暂无数据")])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMore),
      expression: "showMore"
    }],
    staticClass: "more",
    on: {
      "click": _vm.viewMore
    }
  }, [_c('p', [_vm._v("查看更多")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../../static/assets/icon_arrow.png"),
      "alt": ""
    }
  })])], 2)]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "fixed_tel",
    on: {
      "click": function($event) {
        _vm.popupTel = true
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/assets/icon_tel.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('mt-popup', {
    model: {
      value: (_vm.popupTel),
      callback: function($$v) {
        _vm.popupTel = $$v
      },
      expression: "popupTel"
    }
  }, [_c('section', {
    staticClass: "mask_dialog"
  }, [_c('header', [_c('img', {
    attrs: {
      "src": require("../../../static/assets/icon_tel.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("校园服务电话")])]), _vm._v(" "), _c('div', {
    staticClass: "close",
    on: {
      "click": function($event) {
        _vm.popupTel = false
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/assets/cha.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("学校信访办： 67843328")]), _vm._v(" "), _c('p', [_vm._v("校园110： 67843110")]), _vm._v(" "), _c('p', [_vm._v("学生管理科： 67842955")]), _vm._v(" "), _c('p', [_vm._v("心理咨询预约： 67842501")]), _vm._v(" "), _c('p', [_vm._v("学生宿管中心： 67842796")]), _vm._v(" "), _c('p', [_vm._v("学生资助中心： 67842722")]), _vm._v(" "), _c('p', [_vm._v("研究生院： 67842498")]), _vm._v(" "), _c('p', [_vm._v("团委（社团活动）： 67841396")]), _vm._v(" "), _c('p', [_vm._v("食堂服务： 15927076739")]), _vm._v(" "), _c('p', [_vm._v("校园网服务： 67843672")]), _vm._v(" "), _c('p', [_vm._v("教室网络设备服务： 67843900")]), _vm._v(" "), _c('p', [_vm._v("校园卡服务： 67842559、67841627、87058095（北区）")]), _vm._v(" "), _c('p', [_vm._v("校医院急诊： 15802793857")]), _vm._v(" "), _c('p', [_vm._v("毕业生就业： 67842082")]), _vm._v(" "), _c('p', [_vm._v("毕业生档案： 67841629")]), _vm._v(" "), _c('p', [_vm._v("毕业生党组织关系咨询： 6784431")]), _vm._v(" "), _c('p', [_vm._v("学校法律援助中心：67843217")]), _vm._v(" "), _c('p', [_vm._v("物业服务：87383036（东区）、")]), _vm._v(" "), _c('p', [_vm._v("87572081（西区及当代）")])])])])], 1) : _c('mdetail')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/assets/mlogo.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('div', {
    staticClass: "flex-col-center"
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/assets/icon_laixin.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("来信展示")])]), _vm._v(" "), _c('div', {
    staticClass: "title_tip"
  }, [_vm._v("展示管理员选登公开的信件")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bottom"
  }, [_c('p', [_vm._v("版权信息：© 2016 中南民族大学")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a7f3af46!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/mIndex/mIndex.vue
// module id = 570
// module chunks = 0